'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_4fe38840 = {"container":"SliderInput_module_container__20349671","slider":"SliderInput_module_slider__20349671","range":"SliderInput_module_range__20349671"};
require("../../../assets/cjs/components/SliderInput/src/SliderInput~DusIEvdJ.css");

exports.default = modules_4fe38840;
//# sourceMappingURL=SliderInput.module.less.js.map
